import React from "react";
import { FormText } from "reactstrap";

const RequiredFieldNotation = () => {

    return (
        <div className="container">
            <div className="row justify-content-end">
                <FormText className='position-absolute' style={{ marginRight: 14 }}>
                    <p style={{color:'red'}}><strong>*Required Field</strong></p>
                </FormText>
            </div>
        </div>
    )
}

export default RequiredFieldNotation;